import { mapEnumToOptions } from '@abp/ng.core';

export enum OrganizationUnitTypeEnum {
  Turkey = 1,
  EndCustomer = 2
}

export const OrganizationUnitTypeEnumOptions = mapEnumToOptions(OrganizationUnitTypeEnum);
